import { render, staticRenderFns } from "./ProductsEdit.vue?vue&type=template&id=9965a922&"
import script from "./ProductsEdit.vue?vue&type=script&lang=ts&"
export * from "./ProductsEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports